// src/components/home/Trust/Trust.jsx
import React from "react";
import { m, motion } from "framer-motion";
import visit from "../../utils/visit";
import {
  FiShield,
  FiUserCheck,
  FiMapPin,
  FiTrendingUp,
  FiClock,
  FiFileText,
} from "react-icons/fi";
import "./Trust.css";
import { useNavigate } from "react-router-dom";

const ITEMS = [
  {
    icon: <FiShield />,
    title: "Verified Listings",
    desc: "Every listing goes through a basic verification process to reduce risk and fake posts.",
  },
  {
    icon: <FiUserCheck />,
    title: "Trusted Agents",
    desc: "Work with experienced agents for guided visits, pricing clarity, and smooth deals.",
  },
  {
    icon: <FiMapPin />,
    title: "Prime Locations",
    desc: "Explore top areas with high demand—great for living, renting, and long-term value.",
  },
  {
    icon: <FiTrendingUp />,
    title: "Smart Investment",
    desc: "We highlight properties with strong potential based on market trends and demand signals.",
  },
  {
    icon: <FiClock />,
    title: "Fast Scheduling",
    desc: "Book a visit quickly. We prioritize quick response and time-friendly coordination.",
  },
  {
    icon: <FiFileText />,
    title: "Documentation Support",
    desc: "Basic guidance for paperwork and deal steps—so you don’t get stuck in the process.",
  },
];

export default function Trust() {
  const navigate = useNavigate();

  return (
    <section className="trust">
      <div className="container trust__container">
        <motion.div
          className="trust__head"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <span className="trust__kicker">Why Choose Us</span>
          <h2 className="trust__title">
            Trust-first real estate — designed for comfort and clarity.
          </h2>
          <p className="trust__sub">
            We keep the experience clean: verified listings, reliable agents,
            and a process that feels simple from discovery to deal.
          </p>
        </motion.div>

        <div className="trust__grid">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.title}
              className="trustCard"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.05 }}
            >
              <div className="trustCard__icon">{item.icon}</div>
              <div className="trustCard__body">
                <h3 className="trustCard__title">{item.title}</h3>
                <p className="trustCard__desc">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="trust__ctaRow">
          <button
            onClick={() => navigate("/listing")}
            className="trustBtn trustBtn--primary"
            type="button"
          >
            Explore Properties
          </button>
          <a target="_blank" href={visit()}>
            <button className="trustBtn trustBtn--ghost" type="button">
              Talk to an Agent
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}
